"use client";
import { memo } from "react";
import InvestorsComponent, {
  InvestorsProps,
} from "../Chat/Charts/token/About/Investors";
import { ViewMoreButton } from "./ViewMoreButton";

const Investors = memo(({ investors }: Pick<InvestorsProps, "investors">) => {
  return (
    <InvestorsComponent
      investors={investors}
      containerClassName="gap-2"
      titleClassName="!headline_regular_s text-content_primary"
      nameClassName="!body_medium_m"
      investorItemClassName="py-1.5 pl-2 pr-3 rounded-2 gap-2"
      imageHeight={24}
      imageWidth={24}
      enableViewMore={true}
      viewMoreText={<ViewMoreButton iconSize={12} />}
    />
  );
});

Investors.displayName = "Investors";

export { Investors };
export type { InvestorsProps };
